import { Card, Row, Col } from "react-bootstrap";
import linkIcon from "../../../../../../components/Assests/Icons/linkIcon.png";
import dateIcon from "../../../../../../components/Assests/Icons/date.png";
import barcodeIcon from "../../../../../../components/Assests/Icons/barcode.png";
import "./ProductStatusCard.css";

const ProductStatusCard = ({ name, total, completed, id, date, dotColor, setSample, setShowModal }) => {
  return (
    <Card className="product-status-card border-0 shadow-sm">
      <Card.Header className="text-white text-center py-2 fw-medium bg-primary-custom">
        {name}
      </Card.Header>

      <Card.Body className="p-2 d-flex flex-column justify-content-between">
        {/* Top Stats */}
        <Row className="text-center g-3 flex-md-row flex-column">
          <Col className="border-end d-flex flex-column">
            <div className="value-text" style={{ color: "#003087" }}>
              {total} <span className="dot" style={{ backgroundColor: dotColor }} />
            </div>
            <div className="label-text">Total</div>
          </Col>
          <Col>
            <div className="value-text" style={{ color: "#003087" }}>
              {completed}
            </div>
            <div className="label-text">Completed</div>
          </Col>
        </Row>

        <hr className="my-2" />

        {/* Oldest Sample with icon aligned to the right */}
        <div>
          <div className="label-text text-muted mb-1">Oldest Sample</div>

          <div className="d-flex align-items-center justify-content-between">
            {/* Left side: barcode + date */}
            <div>
              <div className="d-flex align-items-center sample-info mb-1 text-dark">
                <img src={barcodeIcon} alt="Sample ID" className="icon-sm me-1" />
                {id}
              </div>
              <div className="d-flex align-items-center sample-info text-dark">
                <img src={dateIcon} alt="Date" className="icon-sm me-1" />
                {date}
              </div>
            </div>

            {/* Right side: link icon */}
            <img
              src={linkIcon}
              alt="View Link"
              className="icon-link cursor-pointer ms-2"
              onClick={() => { setSample(id); setShowModal(true); }}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ProductStatusCard;
